import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { PetlService } from '../../../services/petl.service';
import { PetlBaseComponent } from '../petl-base.component';
var PetlManageProjectsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PetlManageProjectsComponent, _super);
    function PetlManageProjectsComponent(_vcr, petlService, cdr) {
        var _this = _super.call(this, _vcr, petlService, cdr) || this;
        _this.petlService = petlService;
        _this.cdr = cdr;
        _this.reverse = false;
        _this.refreshProjects();
        return _this;
    }
    PetlManageProjectsComponent.prototype.refreshProjects = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        this.projects = null;
                        _a = this;
                        return [4 /*yield*/, this.petlService.getProjectList()];
                    case 1:
                        _a.projects = _b.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlManageProjectsComponent.prototype.renew = function (project) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.petlService.renewProject(project)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.refreshProjects()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlManageProjectsComponent.prototype.delete = function (project) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.petlService.deleteProject(project)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.refreshProjects()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlManageProjectsComponent.prototype.view = function (project) {
        project.mapped = true;
        this.petlService.project = project;
        this.petlService.addProjectToMap(project);
    };
    PetlManageProjectsComponent.prototype.setOrder = function (field) {
        if (this.order === field && !this.reverse) {
            this.reverse = true;
        }
        else {
            this.reverse = null;
        }
        this.order = field;
        this.sort(this.order, this.reverse);
    };
    PetlManageProjectsComponent.prototype.sort = function (fieldName, decending) {
        if (decending === void 0) { decending = false; }
        var negate = decending ? -1 : 1;
        if (this.projects.length > 1) {
            this.projects = this.projects.sort(function (a, b) {
                var type = typeof a[fieldName];
                if (type === 'string') {
                    return (a[fieldName]).localeCompare(b[fieldName]) * negate;
                }
                else if (type === 'number') {
                    return (a[fieldName] - b[fieldName]) * negate;
                }
            });
        }
    };
    return PetlManageProjectsComponent;
}(PetlBaseComponent));
export { PetlManageProjectsComponent };
